import { Button, InputAdornment, InputBaseComponentProps, ListItem, ListItemText, TextField } from "@mui/material";
import React from "react";

interface TextFormListItemProps {
    text: string,
    initialValue: string,
    startAdornmentText?: string,
    endAdornmentText?: string,
    onSave?: (value: string) => void
    onValidate?: (value: string) => void,
    onChange?: (value: string) => void,
    inputProps?: InputBaseComponentProps,
    error?: boolean,
    helperText?: string
}

const TextFormListItem: React.FC<TextFormListItemProps> = ({
    text,
    initialValue,
    startAdornmentText,
    endAdornmentText,
    onSave,
    onValidate,
    onChange,
    inputProps,
    error,
    helperText,
}) => {
    const [value, setValue] = React.useState(initialValue)

    React.useEffect(()=>{
        setValue(initialValue)
    },[initialValue])

    return (
        <ListItem>
            <ListItemText primary={text} />
            <TextField
                variant="standard"
                inputProps={inputProps}
                InputProps={{
                    startAdornment: <InputAdornment position="start">{startAdornmentText}</InputAdornment>,
                    endAdornment: <InputAdornment position="end">{endAdornmentText}</InputAdornment>
                }}
                onChange={e => {
                    if (onValidate) {
                        onValidate(e.target.value)
                    }
                    if (onChange) {
                        onChange(e.target.value)
                    }
                    setValue(e.target.value)
                }}
                error={error ? error : false}
                helperText={helperText}
                value={value}
            />
            {onSave &&
                <Button
                    variant="outlined"
                    sx={{ marginLeft: "1em" }}
                    onClick={() => {
                        onSave(value)
                    }}
                    disabled={error}
                >保存</Button>
            }
        </ListItem>
    );
}

export default TextFormListItem